import { render, staticRenderFns } from "./install-site.vue?vue&type=template&id=9c8c3e64"
import script from "./install-site.vue?vue&type=script&lang=js"
export * from "./install-site.vue?vue&type=script&lang=js"
import style0 from "./install-site.vue?vue&type=style&index=0&id=9c8c3e64&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports